import conversorImg from '@/assets/help/calculadora-conversor.png';
import escoreZImg from '@/assets/help/calculadora-escore-z.png';
import type { HelpArticle } from '../types';

export const TOOLS_ARTICLES: HelpArticle[] = [
    {
        slug: 'conversor-de-escores',
        topicId: 'tools',
        title: 'Converta escores Z, T e percentil',
        description:
            'Transforme um escore em outro em segundos, com leitura na curva normal para apoiar a interpretação.',
        updatedAt: '2026-07-03',
        keywords: ['conversor', 'escore z', 'escore t', 'percentil', 'converter', 'curva normal'],
        blocks: [
            {
                type: 'paragraph',
                text: 'Recebeu um resultado em escore T e precisa do percentil? O **Conversor de escores**, na página **Calculadoras**, faz a conversão entre escore Z, escore T e percentil nas duas direções.',
            },
            {
                type: 'image',
                src: conversorImg,
                alt: 'Conversor de escores com a escala de entrada, o valor informado e os resultados equivalentes',
            },
            { type: 'subheading', id: 'como-usar', text: 'Como usar' },
            {
                type: 'steps',
                items: [
                    'No menu lateral, abra **Calculadoras** e selecione o **Conversor de escores**.',
                    'Escolha a **escala de entrada**: escore Z, escore T ou percentil.',
                    'Digite o valor. Os equivalentes nas outras escalas aparecem na hora.',
                ],
            },
            { type: 'subheading', id: 'curva-normal', text: 'Leitura na curva normal' },
            {
                type: 'paragraph',
                text: 'Abaixo dos resultados, o gráfico da curva normal mostra onde o valor se posiciona na distribuição. É um apoio visual útil para explicar a equivalência entre escalas, inclusive para pais e pacientes.',
            },
            {
                type: 'callout',
                tone: 'info',
                text: 'Referência rápida: escore Z 0 equivale a escore T 50 e ao percentil 50, o centro da distribuição.',
            },
        ],
    },
    {
        slug: 'calculadora-de-escore-z',
        topicId: 'tools',
        title: 'Calcule o escore Z a partir do resultado bruto',
        description:
            'Informe resultado bruto, média e desvio padrão da norma e receba escore Z, escore T e percentil.',
        updatedAt: '2026-07-03',
        keywords: ['calculadora', 'escore z', 'resultado bruto', 'média', 'desvio padrão', 'norma'],
        blocks: [
            {
                type: 'paragraph',
                text: 'Quando o manual do teste traz a média e o desvio padrão da norma, a **Calculadora de Escore Z** faz a padronização para você, sem fórmula no papel nem planilha.',
            },
            {
                type: 'image',
                src: escoreZImg,
                alt: 'Calculadora de Escore Z na página Calculadoras Psicométricas',
            },
            { type: 'subheading', id: 'como-usar', text: 'Como usar' },
            {
                type: 'steps',
                items: [
                    'Na página **Calculadoras**, selecione a **Calculadora de Escore Z**.',
                    'Informe o **resultado bruto** do paciente.',
                    'Informe a **média** e o **desvio padrão** da amostra normativa, conforme o manual do teste.',
                    'Pronto: o escore Z aparece junto com o escore T e o percentil aproximado.',
                ],
            },
            {
                type: 'callout',
                tone: 'warning',
                text: 'Use sempre a norma adequada ao paciente, considerando idade e escolaridade conforme o manual do instrumento. A calculadora padroniza o valor, mas a escolha da norma é decisão clínica.',
            },
        ],
    },
];
